
/**
 * Trending bar.
 */

const trendingToggle = document.querySelector('.trending-toggle');
const trendingItems = document.querySelectorAll('.site-header__trending-nav a');
const trendingNav = document.querySelector('.site-header__trending-nav');
const headerSecondary = document.querySelector('.site-header__secondary');
const trendingWrap = document.querySelector('.site-header__trending');
const trendingToggleWrap = document.querySelector('.site-header__trending-toggle');
/**
* Detect if trending navigation has overflown
*/
function detectTrendingOverflow() {
  if (! trendingNav) {
    return;
  }

  if ((trendingNav.scrollWidth <= trendingNav.offsetWidth) &&
        ! trendingNav.classList.contains('open')) {
    // Hide arrow toggle while all showing
    trendingToggle.parentElement.classList.add('hide');

    // Add items back into tab flow while all showing
    trendingItems.forEach((trendingItem) => {
      trendingItem.removeAttribute('tabindex');
    });
  } else {
    // Show arrow toggle while all showing
    trendingToggle.parentElement.classList.remove('hide');

    // Remove items from tab flow while truncated
    trendingItems.forEach((trendingItem) => {
      // If item is not showing, remove from tab flow
      if (trendingItem.offsetLeft >= trendingNav.offsetWidth) {
        trendingItem.setAttribute('tabindex', '-1');
      }
    });
  }
}
window.addEventListener('load', detectTrendingOverflow);
window.addEventListener('resize', detectTrendingOverflow);

/**
* Toggle the trending menu on click
*/
function toggleTrendingMenu(e) {
  if (! trendingNav) {
    return;
  }

  e.preventDefault();

  headerSecondary.classList.toggle('open');
  trendingToggle.classList.toggle('open');
  trendingNav.classList.toggle('open');
  trendingWrap.classList.toggle('open');

  trendingItems.forEach((trendingItem) => {
    // Remove all tabindex attributes
    trendingItem.removeAttribute('tabindex');

    // Adds tabindex attribute if overflow is present
    if (trendingItem.offsetLeft >= trendingNav.offsetWidth) {
      trendingItem.setAttribute('tabindex', '-1');
    }
  });

  // Move toggle for a more natural tab flow
  if (trendingNav.classList.contains('open')) {
    // Moves before nav menu when menu is open
    trendingWrap.insertBefore(trendingToggleWrap, trendingNav);
  } else {
    // Moves after nav menu when menu is closed
    trendingWrap.insertBefore(trendingToggleWrap, trendingNav.nextSibling);
  }
}

if (trendingToggle) {
  trendingToggle.addEventListener('click', toggleTrendingMenu);
}
